// extracted by mini-css-extract-plugin
export var emailBlockLink = "_l2-0";